import StoreBadges from './StoreBadges';
import { PhoneFrame } from './Devices';
import collectionsScreen from '../assets/images/mobile1.jpg';
import galleryScreen from '../assets/images/mobile2.jpg';

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero__copy">
        <h1 className="hero__title fade-up fade-up--1">
          Every moment,
          <br />
          all in one place.
        </h1>

        <p className="hero__lead fade-up fade-up--2">
          Create a collection, share a QR code or link, and collect every photo and video
          your guests captured.
        </p>

        <div className="hero__actions fade-up fade-up--3">
          <StoreBadges />
        </div>
      </div>

      <div className="hero__devices fade-up fade-up--4">
        <div className="device-pair">
          <PhoneFrame
            className="device-pair__back"
            src={collectionsScreen}
            alt="ShareShutter on a phone, showing a host's list of event collections"
            eager
          />
          <PhoneFrame
            className="device-pair__front"
            src={galleryScreen}
            alt="A ShareShutter collection on a phone, with a grid of photos and videos guests uploaded"
            eager
          />
        </div>
      </div>
    </section>
  );
}
